import { InsuranceProduct } from 'types';
import { CapitolaClient } from './base';

export default class InsuranceProductClient extends CapitolaClient<InsuranceProduct> {
  public get resourceName(): string {
    return 'insurance-product';
  }
}
